import ExpandMore from '@mui/icons-material/ExpandMore';
import PaletteOutlined from '@mui/icons-material/PaletteOutlined';
import { Box, List, ListItem } from '@mui/material';

import Popper from '@/components/Popper';
import { PreviewImageTooltip } from '@/components/PreviewImageTooltip';
import Typography from '@/components/Typography';
import { Z_INDEX } from '@/constants/z-index';
import { chartPaletteSelection } from '@/features/Dashboard/form/AppForm/components/ColorPaletteSelector/const';
import { useAppForm } from '@/features/Dashboard/form/AppForm/context';

const ApplyPaletteDropdown = () => {
  const { form } = useAppForm();

  const applyPaletteButton = (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 164 }}>
      <PaletteOutlined />
      <Typography size={14}>Apply palette</Typography>
      <ExpandMore sx={{ ml: 1, mr: '0!important' }} />
    </Box>
  );

  return (
    <form.Subscribe selector={s => s.values?.symbols}>
      {symbols => {
        const activeLength = symbols?.active.length ?? 0;

        return (
          <Popper
            closeOnClickInside
            buttonContent={applyPaletteButton}
            buttonVariant='text'
            disabled={activeLength === 0}
            placement='bottom-start'
            sx={{
              height: 33
            }}
            buttonStyles={theme => ({
              opacity: '1 !important',
              backgroundColor:
                activeLength === 0
                  ? theme.palette.gx.textDisabled
                  : theme.palette.gx.actionBarButtonTile,
              color: activeLength === 0 ? theme.palette.gx.neutral : theme.palette.text.primary,
              '&.Mui-disabled': {
                color: theme.palette.gx.neutral
              }
            })}
            zIndex={Z_INDEX.panelFloating}
          >
            <Box
              sx={theme => ({
                display: 'flex',
                backgroundColor: theme.palette.gx.actionBarButtonTile,
                flexDirection: 'column',
                fontSize: '14px',
                width: 180,
                maxHeight: 424,
                overflowY: 'auto'
              })}
            >
              <List disablePadding>
                {chartPaletteSelection.map(({ id, name, paletteImage }) => {
                  return (
                    <PreviewImageTooltip
                      key={name}
                      height={50}
                      previewImage={paletteImage}
                    >
                      <ListItem
                        sx={theme => ({
                          m: 1,
                          width: 164,
                          cursor: 'pointer',
                          backgroundColor: `${theme.palette.text.primary}33`,
                          '&:hover': {
                            backgroundColor: `${theme.palette.text.primary}66`
                          }
                        })}
                        onClick={() => {
                          form.setFieldValue('colorPalette', id);
                        }}
                      >
                        <Typography
                          sx={{ fontWeight: 500, fontSize: 12 }}
                          variant='caption'
                        >
                          {name}
                        </Typography>
                      </ListItem>
                    </PreviewImageTooltip>
                  );
                })}
              </List>
            </Box>
          </Popper>
        );
      }}
    </form.Subscribe>
  );
};
export default ApplyPaletteDropdown;
